import { React } from "react";
import { Button } from "@mui/material";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

import './My.scss';

export function MyButtonBack(props) {

  
  return (
      <Button  {...props} 
        variant="contained" 
        className={"myback " + (props.className ? props.className : '')} 
        onClick={props.onClick}
        startIcon={<ArrowLeftIcon sx={{ color: "#26C1C9", fontSize: "50px" }} />}
      > {props.children}</Button>
  );
}

